var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%" } }, [
    _c(
      "div",
      { staticClass: "table_wrapper" },
      [
        _c(
          "div",
          { staticClass: "table_wrapper_search mb16" },
          [
            _c(
              "yxt-select",
              {
                staticStyle: { width: "200px" },
                attrs: { placeholder: _vm.$t("pc_biz_lbl_selecttip") },
                on: {
                  change: function ($event) {
                    return _vm.getSkillsList(true)
                  },
                },
                model: {
                  value: _vm.selectType,
                  callback: function ($$v) {
                    _vm.selectType = $$v
                  },
                  expression: "selectType",
                },
              },
              _vm._l(_vm.typeOptions, function (item) {
                return _c("yxt-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c("yxt-input", {
              staticClass: "keyword ml12",
              staticStyle: { width: "280px" },
              attrs: {
                placeholder: _vm.$t("pc_biz_gwnl_pleaseEnterLabelName", {
                  prefixLabel: _vm.prefixLabel,
                }),
                searchable: "",
              },
              on: {
                search: function ($event) {
                  return _vm.getSkillsList(true)
                },
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.getSkillsList(true)
                },
              },
              model: {
                value: _vm.params.searchKey,
                callback: function ($$v) {
                  _vm.$set(_vm.params, "searchKey", $$v)
                },
                expression: "params.searchKey",
              },
            }),
          ],
          1
        ),
        _c(
          "yxt-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "multipleTable",
            staticClass: "person-table",
            attrs: {
              "row-key": "id",
              data: _vm.tableData,
              "max-height": _vm.maxHeight,
            },
            on: {
              select: _vm.handleSingleSeletct,
              "select-all": _vm.handleSelectAll,
            },
          },
          [
            _c("yxt-table-column", {
              attrs: {
                type: "selection",
                "show-overflow-tooltip": false,
                selectable: _vm.selectEvent,
                "class-name": "table-selection-odd",
                width: "55",
              },
            }),
            _c("yxt-table-column", {
              attrs: {
                label: _vm.$t("biz_ability_abilityName"),
                "min-width": "180",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        { staticClass: "flex gwnl-flex-width" },
                        [
                          _c(
                            "yxt-popover",
                            {
                              staticClass: "ellipsis",
                              attrs: {
                                placement: "top",
                                trigger: "hover",
                                "show-scroll": "",
                                "max-width": "198",
                                "max-height": "144",
                                "open-filter": true,
                                content: row.name,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "ellipsis",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(row.name) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          row.cloudType
                            ? _c(
                                "div",
                                { staticClass: "flex-1" },
                                [
                                  _c(
                                    "yxt-tag",
                                    {
                                      staticClass: "ml8",
                                      attrs: { size: "mini" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("pc_biz_gwnl_global_cloud")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("yxt-table-column", {
              attrs: {
                label: _vm.$t("biz_ability_abilityType"),
                "min-width": "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getAbilityType(row.general)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("yxt-table-column", {
              attrs: {
                label: _vm.$t("biz_ability_abilityDesc"),
                "min-width": "320",
                "show-overflow-tooltip": "",
                prop: "description",
              },
            }),
          ],
          1
        ),
        _c("gwnl-pager", {
          attrs: { pager: _vm.pager },
          on: {
            searchData: function ($event) {
              return _vm.getSkillsList()
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }